export class DepositEventType {

	static STEPS = {
		DEPOSIT_DATA: 'DEPOSIT_DATA',
		DEPOSIT_CONFIRM: 'DEPOSIT_CONFIRM',
		DEPOSIT_RESULT: 'DEPOSIT_RESULT'
	};

	static MODAL = {
		TRUE_MODAL: 'TRUE_MODAL'
	};

	static SEND = {
		DEPOSIT_DATA_SEND: 'DEPOSIT_DATA_SEND',
		DEPOSIT_DATA_CONFIRM: 'DEPOSIT_DATA_CONFIRM'
	};

	static ERROR = 'DEPOSIT_ERROR';
	static BUTTONS = 'DEPOSIT_BUTTONS';

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/deposit-per-ticket/deposit-per-ticket.event.type.ts